//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL_ADMINISTRATOR = new InjectionToken<string>('API_BASE_URL_ADMINISTRATOR');

@Injectable()
export class AdministratorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_ADMINISTRATOR) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Post account
     * @param body (optional) The account to create
     * @return The created or updated account
     */
    createAccount(body?: CreateAccountDto | undefined): Observable<AccountDto> {
        let url_ = this.baseUrl + "/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto>;
        }));
    }

    protected processCreateAccount(response: HttpResponseBase): Observable<AccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = AccountDto.fromJS(resultData201);
                return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto>(null as any);
    }

    /**
     * Get accounts
     * @return Returns a list of accounts
     */
    getAllAccounts(): Observable<AccountDto[]> {
        let url_ = this.baseUrl + "/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto[]>;
        }));
    }

    protected processGetAllAccounts(response: HttpResponseBase): Observable<AccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AccountDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto[]>(null as any);
    }

    /**
     * Put account
     * @param body (optional) The account to update
     * @return The updated account
     */
    updateAccount(body?: AccountDto | undefined): Observable<AccountDto> {
        let url_ = this.baseUrl + "/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto>;
        }));
    }

    protected processUpdateAccount(response: HttpResponseBase): Observable<AccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result204: any = null;
                let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = AccountDto.fromJS(resultData204);
                return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto>(null as any);
    }

    /**
     * Get one account
     * @return Returns an account
     */
    getAccount(id: string): Observable<AccountDto> {
        let url_ = this.baseUrl + "/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto>;
        }));
    }

    protected processGetAccount(response: HttpResponseBase): Observable<AccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto>(null as any);
    }

    /**
     * Get clients by account id
     * @param id The account id
     * @param atsEnabled (optional) Indicate if ats is enabled for the clients
     * @return Returns a list of clients of the specified account
     */
    getClientsForAccount(id: string, atsEnabled?: boolean | undefined): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/accounts/{id}/clients?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (atsEnabled === null)
            throw new Error("The parameter 'atsEnabled' cannot be null.");
        else if (atsEnabled !== undefined)
            url_ += "atsEnabled=" + encodeURIComponent("" + atsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetClientsForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processGetClientsForAccount(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ClientDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto[]>(null as any);
    }

    /**
     * Get job scans for account
     * @param id The id of the account you want to get the job scans for
     * @param externalRef (optional) The unique reference of the job scan at the account side
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning job scans should include expectations or not
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of job scans for the specified account
     */
    getJobScansForAccount(id: string, externalRef?: string | undefined, shouldHaveExpectations?: boolean | undefined, includeExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, offset?: number | undefined, count?: number | undefined, sort?: string | undefined, search?: string | undefined, domainIds?: string | undefined): Observable<JobScanDto[]> {
        let url_ = this.baseUrl + "/accounts/{id}/jobscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJobScansForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScansForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobScanDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobScanDto[]>;
        }));
    }

    protected processGetJobScansForAccount(response: HttpResponseBase): Observable<JobScanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(JobScanDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanDto[]>(null as any);
    }

    /**
     * Get job scans for account and client type
     * @param id The id of the account you want to get the job scans for
     * @param clientTypeId The id of the client type you want to get the job scans for
     * @param externalRef (optional) The unique reference of the job scan at the account side
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning job scans should include expectations or not
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of job scans for the specified account
     */
    getJobScansForAccountAndClientType(id: string, clientTypeId: number, externalRef?: string | undefined, shouldHaveExpectations?: boolean | undefined, includeExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, offset?: number | undefined, count?: number | undefined, sort?: string | undefined, search?: string | undefined, domainIds?: string | undefined): Observable<JobScanDto[]> {
        let url_ = this.baseUrl + "/accounts/{id}/clienttype/{clientTypeId}/jobscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clientTypeId === undefined || clientTypeId === null)
            throw new Error("The parameter 'clientTypeId' must be defined.");
        url_ = url_.replace("{clientTypeId}", encodeURIComponent("" + clientTypeId));
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJobScansForAccountAndClientType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScansForAccountAndClientType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobScanDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobScanDto[]>;
        }));
    }

    protected processGetJobScansForAccountAndClientType(response: HttpResponseBase): Observable<JobScanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(JobScanDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanDto[]>(null as any);
    }

    /**
     * Get the total number of job scans for the account
     * @param id The account id
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not.
                This parameter is ignored if there are team role ids or work value ids.
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns the total number of job scans for the account
     */
    getTotalNumberOfJobScansForAccount(id: string, shouldHaveExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, search?: string | undefined, domainIds?: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/accounts/{id}/jobscans/totalcount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTotalNumberOfJobScansForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalNumberOfJobScansForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalNumberOfJobScansForAccount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * Get the total number of job scans for the account
     * @param id The account id
     * @param clientTypeId The client type id
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not.
                This parameter is ignored if there are team role ids or work value ids.
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns the total number of job scans for the account
     */
    getTotalNumberOfJobScansForAccountAndClientType(id: string, clientTypeId: number, shouldHaveExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, search?: string | undefined, domainIds?: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/accounts/{id}/clienttype/{clientTypeId}/jobscans/totalcount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clientTypeId === undefined || clientTypeId === null)
            throw new Error("The parameter 'clientTypeId' must be defined.");
        url_ = url_.replace("{clientTypeId}", encodeURIComponent("" + clientTypeId));
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTotalNumberOfJobScansForAccountAndClientType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalNumberOfJobScansForAccountAndClientType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalNumberOfJobScansForAccountAndClientType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * Get talent scans for account
     * @param id The account id
     * @param externalRef (optional) The unique reference of the talentscan at the account side
     * @param shouldHaveExpectations (optional) Whether the talent scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning talent scans should include expectations or not
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma-separated list of domain ids
     * @param atsClientId (optional) The Ats Client id
     * @return Returns a list of talent scans for the specified account
     */
    getTalentScansForAccount(id: string, externalRef?: string | undefined, shouldHaveExpectations?: boolean | undefined, includeExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, offset?: number | undefined, count?: number | undefined, sort?: string | undefined, search?: string | undefined, domainIds?: string | undefined, atsClientId?: string | undefined): Observable<TalentScanDto[]> {
        let url_ = this.baseUrl + "/accounts/{id}/talentscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        if (atsClientId === null)
            throw new Error("The parameter 'atsClientId' cannot be null.");
        else if (atsClientId !== undefined)
            url_ += "atsClientId=" + encodeURIComponent("" + atsClientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTalentScansForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScansForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TalentScanDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TalentScanDto[]>;
        }));
    }

    protected processGetTalentScansForAccount(response: HttpResponseBase): Observable<TalentScanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(TalentScanDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanDto[]>(null as any);
    }

    /**
     * Get the total number of talent scans for the account
     * @param id The account id
     * @param shouldHaveExpectations (optional) Whether the talent scan should have expectations or not. This parameter is ignored if there
    are team role ids or work value ids.
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids to filter on
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns the total number of talent scans for the account
     */
    getTotalNumberOfTalentScansForAccount(id: string, shouldHaveExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, search?: string | undefined, domainIds?: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/accounts/{id}/talentscans/totalcount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTotalNumberOfTalentScansForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalNumberOfTalentScansForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalNumberOfTalentScansForAccount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * Send email
     * @param body (optional) 
     * @return Success
     */
    sendEmail(body?: EmailActionDto | undefined): Observable<EmailActionDto> {
        let url_ = this.baseUrl + "/actions/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailActionDto>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<EmailActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmailActionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Accepted http response code", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailActionDto>(null as any);
    }

    /**
     * Get ATS Client by name
     * @param name The unique name of the ATS Client
     * @return Success
     */
    getAtsClientByName(name: string): Observable<AtsClientDto> {
        let url_ = this.baseUrl + "/atsclients/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAtsClientByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAtsClientByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AtsClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AtsClientDto>;
        }));
    }

    protected processGetAtsClientByName(response: HttpResponseBase): Observable<AtsClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AtsClientDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AtsClientDto>(null as any);
    }

    /**
     * Create AtsClient
     * @param body (optional) The Ats client to create
     * @return Returns the created AtsClient
     */
    createAtsClient(body?: CreateAtsClientDto | undefined): Observable<AtsClientDto> {
        let url_ = this.baseUrl + "/atsclients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAtsClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAtsClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AtsClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AtsClientDto>;
        }));
    }

    protected processCreateAtsClient(response: HttpResponseBase): Observable<AtsClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AtsClientDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AtsClientDto>(null as any);
    }

    /**
     * Update ATS client
     * @param body (optional) The ATS client to update
     * @return The updated ATS client
     */
    updateAtsClient(body?: AtsClientDto | undefined): Observable<AtsClientDto> {
        let url_ = this.baseUrl + "/atsclients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAtsClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAtsClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AtsClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AtsClientDto>;
        }));
    }

    protected processUpdateAtsClient(response: HttpResponseBase): Observable<AtsClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = AtsClientDto.fromJS(resultData201);
                return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AtsClientDto>(null as any);
    }

    /**
     * Create a talent scan for the specified client
     * @param id The unique identifier of the client.
     * @param language (optional) The two-letter iso code for the talent scan's language, eg 'en'
     * @param body (optional) The talent scan to be created
     * @return Success
     */
    createTalentScanForClient(id: string, language?: string | undefined, body?: CreateTalentScanDto | undefined): Observable<TalentScanDto> {
        let url_ = this.baseUrl + "/clients/{id}/talentscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTalentScanForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTalentScanForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TalentScanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TalentScanDto>;
        }));
    }

    protected processCreateTalentScanForClient(response: HttpResponseBase): Observable<TalentScanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TalentScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanDto>(null as any);
    }

    /**
     * Get Clients
     * @return Returns a list of clients
     */
    getAllClients(): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processGetAllClients(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ClientDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto[]>(null as any);
    }

    /**
     * Get one client
     * @return Returns a client
     */
    getClientById(id: string): Observable<ClientDto> {
        let url_ = this.baseUrl + "/clients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetClientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processGetClientById(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClientDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto>(null as any);
    }

    /**
     * Get permissions
     * @return Success
     */
    getPermissions(): Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDto[]>;
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(PermissionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDto[]>(null as any);
    }

    /**
     * Get template
     * @param body (optional) Contains the template name, language and placeholders
     * @return Success
     */
    getTemplate(body?: TemplateRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Get current authenticated user
     * @return Success
     */
    getMe(): Observable<UserDto> {
        let url_ = this.baseUrl + "/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetMe(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * Get accounts for the current authenticated user
     * @return Success
     */
    getMyActiveAccounts(): Observable<AccountDto[]> {
        let url_ = this.baseUrl + "/users/me/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyActiveAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyActiveAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto[]>;
        }));
    }

    protected processGetMyActiveAccounts(response: HttpResponseBase): Observable<AccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AccountDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto[]>(null as any);
    }

    /**
     * Create or update a user
     * @param body (optional) The user to be created or updated
     * @return Success
     */
    updateUser(body?: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }
}

export class AccountDto implements IAccountDto {
    id?: string;
    name?: string | undefined;
    active?: boolean;
    logoUrl?: string | undefined;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface IAccountDto {
    id?: string;
    name?: string | undefined;
    active?: boolean;
    logoUrl?: string | undefined;
}

export class ApiError implements IApiError {
    code?: string;
    description?: string | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IApiError {
    code?: string;
    description?: string | undefined;
}

export class ApiErrorResponse implements IApiErrorResponse {
    apiError?: ApiError;
    correlationId?: string;
    errorMessage?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
    detail?: string | undefined;

    constructor(data?: IApiErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiError = _data["apiError"] ? ApiError.fromJS(_data["apiError"]) : <any>undefined;
            this.correlationId = _data["correlationId"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationError.fromJS(item));
            }
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): ApiErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiError"] = this.apiError ? this.apiError.toJSON() : <any>undefined;
        data["correlationId"] = this.correlationId;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        data["detail"] = this.detail;
        return data;
    }
}

export interface IApiErrorResponse {
    apiError?: ApiError;
    correlationId?: string;
    errorMessage?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
    detail?: string | undefined;
}

export class AtsClientDto implements IAtsClientDto {
    name?: string | undefined;
    atsId?: string;
    accountId?: string | undefined;
    apiId?: string | undefined;
    apiToken?: string | undefined;
    id?: string;
    active?: boolean;

    constructor(data?: IAtsClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.atsId = _data["atsId"];
            this.accountId = _data["accountId"];
            this.apiId = _data["apiId"];
            this.apiToken = _data["apiToken"];
            this.id = _data["id"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): AtsClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtsClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["atsId"] = this.atsId;
        data["accountId"] = this.accountId;
        data["apiId"] = this.apiId;
        data["apiToken"] = this.apiToken;
        data["id"] = this.id;
        data["active"] = this.active;
        return data;
    }
}

export interface IAtsClientDto {
    name?: string | undefined;
    atsId?: string;
    accountId?: string | undefined;
    apiId?: string | undefined;
    apiToken?: string | undefined;
    id?: string;
    active?: boolean;
}

export class ClientDto implements IClientDto {
    id?: string;
    name?: string | undefined;
    accountId?: string;
    theme?: string | undefined;
    talentScanUrl?: string | undefined;
    displayName?: string | undefined;
    adminReportUrl?: string | undefined;
    defaultReportUrl?: string | undefined;
    ccReportUrl?: string | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.accountId = _data["accountId"];
            this.theme = _data["theme"];
            this.talentScanUrl = _data["talentScanUrl"];
            this.displayName = _data["displayName"];
            this.adminReportUrl = _data["adminReportUrl"];
            this.defaultReportUrl = _data["defaultReportUrl"];
            this.ccReportUrl = _data["ccReportUrl"];
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["accountId"] = this.accountId;
        data["theme"] = this.theme;
        data["talentScanUrl"] = this.talentScanUrl;
        data["displayName"] = this.displayName;
        data["adminReportUrl"] = this.adminReportUrl;
        data["defaultReportUrl"] = this.defaultReportUrl;
        data["ccReportUrl"] = this.ccReportUrl;
        return data;
    }
}

export interface IClientDto {
    id?: string;
    name?: string | undefined;
    accountId?: string;
    theme?: string | undefined;
    talentScanUrl?: string | undefined;
    displayName?: string | undefined;
    adminReportUrl?: string | undefined;
    defaultReportUrl?: string | undefined;
    ccReportUrl?: string | undefined;
}

export class CreateAccountDto implements ICreateAccountDto {
    name?: string | undefined;
    logoUrl?: string | undefined;

    constructor(data?: ICreateAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): CreateAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface ICreateAccountDto {
    name?: string | undefined;
    logoUrl?: string | undefined;
}

export class CreateAtsClientDto implements ICreateAtsClientDto {
    name?: string | undefined;
    atsId?: string;
    accountId?: string | undefined;
    apiId?: string | undefined;
    apiToken?: string | undefined;

    constructor(data?: ICreateAtsClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.atsId = _data["atsId"];
            this.accountId = _data["accountId"];
            this.apiId = _data["apiId"];
            this.apiToken = _data["apiToken"];
        }
    }

    static fromJS(data: any): CreateAtsClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAtsClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["atsId"] = this.atsId;
        data["accountId"] = this.accountId;
        data["apiId"] = this.apiId;
        data["apiToken"] = this.apiToken;
        return data;
    }
}

export interface ICreateAtsClientDto {
    name?: string | undefined;
    atsId?: string;
    accountId?: string | undefined;
    apiId?: string | undefined;
    apiToken?: string | undefined;
}

export class CreateTalentScanDto implements ICreateTalentScanDto {
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;
    theme?: string | undefined;

    constructor(data?: ICreateTalentScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): CreateTalentScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTalentScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        data["theme"] = this.theme;
        return data;
    }
}

export interface ICreateTalentScanDto {
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;
    theme?: string | undefined;
}

export class EmailActionDto implements IEmailActionDto {
    fromAddress?: string | undefined;
    destinationAddresses?: string[] | undefined;
    ccAddresses?: string[] | undefined;
    bccAddresses?: string[] | undefined;
    subject?: string | undefined;
    htmlBody?: string | undefined;
    templateRequest?: TemplateRequestDto;

    constructor(data?: IEmailActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromAddress = _data["fromAddress"];
            if (Array.isArray(_data["destinationAddresses"])) {
                this.destinationAddresses = [] as any;
                for (let item of _data["destinationAddresses"])
                    this.destinationAddresses!.push(item);
            }
            if (Array.isArray(_data["ccAddresses"])) {
                this.ccAddresses = [] as any;
                for (let item of _data["ccAddresses"])
                    this.ccAddresses!.push(item);
            }
            if (Array.isArray(_data["bccAddresses"])) {
                this.bccAddresses = [] as any;
                for (let item of _data["bccAddresses"])
                    this.bccAddresses!.push(item);
            }
            this.subject = _data["subject"];
            this.htmlBody = _data["htmlBody"];
            this.templateRequest = _data["templateRequest"] ? TemplateRequestDto.fromJS(_data["templateRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromAddress"] = this.fromAddress;
        if (Array.isArray(this.destinationAddresses)) {
            data["destinationAddresses"] = [];
            for (let item of this.destinationAddresses)
                data["destinationAddresses"].push(item);
        }
        if (Array.isArray(this.ccAddresses)) {
            data["ccAddresses"] = [];
            for (let item of this.ccAddresses)
                data["ccAddresses"].push(item);
        }
        if (Array.isArray(this.bccAddresses)) {
            data["bccAddresses"] = [];
            for (let item of this.bccAddresses)
                data["bccAddresses"].push(item);
        }
        data["subject"] = this.subject;
        data["htmlBody"] = this.htmlBody;
        data["templateRequest"] = this.templateRequest ? this.templateRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmailActionDto {
    fromAddress?: string | undefined;
    destinationAddresses?: string[] | undefined;
    ccAddresses?: string[] | undefined;
    bccAddresses?: string[] | undefined;
    subject?: string | undefined;
    htmlBody?: string | undefined;
    templateRequest?: TemplateRequestDto;
}

export class ExpectationDto implements IExpectationDto {
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;

    constructor(data?: IExpectationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    }

    static fromJS(data: any): ExpectationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpectationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data;
    }
}

export interface IExpectationDto {
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;
}

export class JobScanDto implements IJobScanDto {
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;
    theme?: string | undefined;
    id?: string;
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;

    constructor(data?: IJobScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [] as any;
                for (let item of _data["contactCcEmail"])
                    this.contactCcEmail!.push(item);
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
            this.theme = _data["theme"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [] as any;
                for (let item of _data["expectations"])
                    this.expectations!.push(ExpectationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (let item of this.contactCcEmail)
                data["contactCcEmail"].push(item);
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        data["theme"] = this.theme;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (let item of this.expectations)
                data["expectations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobScanDto {
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;
    theme?: string | undefined;
    id?: string;
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    id?: string;
    name?: string | undefined;
    action?: string | undefined;
    resource?: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.action = _data["action"];
            this.resource = _data["resource"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["action"] = this.action;
        data["resource"] = this.resource;
        return data;
    }
}

export interface IPermissionDto {
    id?: string;
    name?: string | undefined;
    action?: string | undefined;
    resource?: string | undefined;
}

export class TalentScanDto implements ITalentScanDto {
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;
    theme?: string | undefined;
    id?: string;
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;

    constructor(data?: ITalentScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
            this.theme = _data["theme"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [] as any;
                for (let item of _data["expectations"])
                    this.expectations!.push(ExpectationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TalentScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new TalentScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        data["theme"] = this.theme;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (let item of this.expectations)
                data["expectations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITalentScanDto {
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;
    theme?: string | undefined;
    id?: string;
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;
}

export class TemplateRequestDto implements ITemplateRequestDto {
    filePath?: string | undefined;
    placeholders?: { [key: string]: string; } | undefined;

    constructor(data?: ITemplateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"];
            if (_data["placeholders"]) {
                this.placeholders = {} as any;
                for (let key in _data["placeholders"]) {
                    if (_data["placeholders"].hasOwnProperty(key))
                        (<any>this.placeholders)![key] = _data["placeholders"][key];
                }
            }
        }
    }

    static fromJS(data: any): TemplateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        if (this.placeholders) {
            data["placeholders"] = {};
            for (let key in this.placeholders) {
                if (this.placeholders.hasOwnProperty(key))
                    (<any>data["placeholders"])[key] = (<any>this.placeholders)[key];
            }
        }
        return data;
    }
}

export interface ITemplateRequestDto {
    filePath?: string | undefined;
    placeholders?: { [key: string]: string; } | undefined;
}

export class UserDto implements IUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    ssoId?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.ssoId = _data["ssoId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["ssoId"] = this.ssoId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    ssoId?: string | undefined;
    displayName?: string | undefined;
}

export class ValidationError implements IValidationError {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
    validationErrors?: ValidationError[] | undefined;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationError {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}